import script from "./MailBoxContentLV.vue?vue&type=script&setup=true&lang=js"
export * from "./MailBoxContentLV.vue?vue&type=script&setup=true&lang=js"

import "./MailBoxContentLV.vue?vue&type=style&index=0&id=5517d98a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5517d98a"]])

export default __exports__